import Modal from '@paytrace/pt-skel/Component/Modal'
import React from 'react'

interface StateCheckAlertProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  isSurchargeAvailable: boolean;
  isStateAvailable: boolean;
}

// Shows when the customer.state does not allow Surcharge
const SurchargeNotAvailableMessage = () => (
  <p>Surcharge is not available in the cardholder&apos;s state.</p>
)

// Shows when the customer.state is empty
const NoStateMessage = () => (
  <p>
    The selected customer does not have a valid state saved on their profile. To
    enable surcharge for this recurring payment, please update the customer
    profile with their state and try again.
  </p>
)

export default function StateCheckAlert ({
  isOpen,
  setIsOpen,
  isSurchargeAvailable,
  isStateAvailable,
}: StateCheckAlertProps) {
  const WhichAlertToShow = () => {
    if (!isStateAvailable) {
      return <NoStateMessage />
    }

    if (!isSurchargeAvailable) {
      return <SurchargeNotAvailableMessage />
    }

    return null
  }

  const alertContent = WhichAlertToShow()

  if (!isOpen || !alertContent) {
    return null
  }

  return (
    <Modal
      open={isOpen}
      onClose={() => setIsOpen(false)}
      className="state-check-modal"
    >
      <div style={{ textAlign: 'center' }}>
        <h1>ALERT!</h1>
        {alertContent}
        <button onClick={() => setIsOpen(false)}>Close</button>
      </div>
    </Modal>
  )
}
